export const stickyActionHeaderStyle = {
  position: "sticky",
  right: 0,
  backgroundColor: "#f8f9fa",
  boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
};

export const stickyActionCellStyle = {
  position: "sticky",
  right: 0,
  backgroundColor: "#fff",
  boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
};
